import * as React from "react";
import Container from "./styles";
import type { TypeCharacterCounterProps } from "./CharacterCounterTypes";

const CharacterCounterStyled = React.forwardRef<
  HTMLDivElement,
  TypeCharacterCounterProps
>(
  (
    { currentValue, maxValue, size = "default", mode = "countdown", ...rest },
    ref
  ) => {
    const remaining = maxValue - currentValue;
    const displayValue = mode === "countup" ? currentValue : remaining;
    return (
      <Container
        ref={ref}
        role="status"
        mini={size === "mini"}
        overlimit={remaining < 0}
        {...rest}
      >
        {displayValue}
      </Container>
    );
  }
);

CharacterCounterStyled.displayName = "CharacterCounter";
export default CharacterCounterStyled;
